import * as React from 'react';
import NavBar from './NavBar';
import HeaderImage from './HeaderImage';
import Footer from './Footer';
import { Stack, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import ContentWrapper from './ContentWrapper';

const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(0),
}));

export default function Layout({ children }) {
  return (
    <Stack
      direction='column'
      justifyContent='space-between'
      alignItems='stretch'
      style={{ height: '100%' }}
    >
      <Item elevation={0} square>
        <NavBar />
        <HeaderImage />
        <ContentWrapper>{children}</ContentWrapper>
      </Item>
      <Item elevation={0} square>
        <Footer />
      </Item>
    </Stack>
  );
}
